/* <mf-tabs> — Webflow tabs: current pane fades out (100ms), then the new one fades in (300ms, ease). */
if (!customElements.get('mf-tabs')) {
  class MfTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-mf-tab]'));
      this.panes = Array.from(this.querySelectorAll('[data-mf-tab-pane]'));
      this.tabs.forEach((tab, index) =>
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(index);
        })
      );
    }

    select(index) {
      const current = this.panes.findIndex((pane) => pane.classList.contains('w--tab-active'));
      if (index === current || this.switching) return;
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('w--current', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      const outgoing = this.panes[current];
      const incoming = this.panes[index];
      this.switching = true;
      outgoing
        .animate([{ opacity: 1 }, { opacity: 0 }], { duration: 100, easing: 'ease' })
        .finished.finally(() => {
          outgoing.classList.remove('w--tab-active');
          incoming.classList.add('w--tab-active');
          incoming.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease' });
          this.switching = false;
        });
    }
  }
  customElements.define('mf-tabs', MfTabs);
}
